import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { RealtimeProvider } from '../realtime/RealtimeProvider';
import { useAuth } from './useAuth';

/** Tenant pages need a workspace; a super admin who hasn't opened one goes to the platform overview. */
export function RequireWorkspace() {
  const { workspace } = useAuth();
  if (!workspace) return <Navigate to="/admin" replace />;
  // Live updates for every tenant page; a new workspace gets a fresh socket.
  return (
    <RealtimeProvider key={workspace.id} workspaceId={workspace.id}>
      <Outlet />
    </RealtimeProvider>
  );
}

/** `/` → the inbox inside a workspace, or the platform overview for a super admin outside one. */
export function HomeRedirect() {
  const { workspace } = useAuth();
  return <Navigate to={workspace ? '/inbox' : '/admin'} replace />;
}

/**
 * Platform console pages: always outside any client. Arriving here (sidebar link, back button, typed
 * URL) while a client workspace is open closes it, so the console never runs under a client's banner.
 */
export function PlatformArea() {
  const { workspace, isPlatformAdmin, leaveWorkspace } = useAuth();
  const inside = isPlatformAdmin && !!workspace;
  useEffect(() => {
    if (inside) leaveWorkspace({ navigate: false });
  }, [inside, leaveWorkspace]);
  return <Outlet />;
}
